import React, { Component } from 'react';
import { connect } from 'react-redux';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import ErrorBoundaryMessage from './ErrorBoundaryMessage';

class DataCardErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    captureExceptionWithScope(error, {
      boundaryName: 'AlertsDataCard#ErrorBoundary',
      stackTrace: errorInfo,
      currentAdrData: JSON.stringify(this.props.currentAdrData),
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorBoundaryMessage isCentralStation={this.props.isCentralStation} />
      );
    }
    return this.props.children;
  }
}
const mapStateToProps = state => {
  const currentAdrData =
    state?.adrData?.data?.[`alert://${state?.incidents?.selectedAlertID}`];
  return {
    currentAdrData,
    isCentralStation:
      state?.sinatra?.user?.currentRole?.application === 'central_station',
  };
};

export default connect(mapStateToProps)(DataCardErrorBoundary);
